<template>
  <div class="justify-center text-center py-7 mx-auto white rounded-lg  " style="width: 90vw">
      <v-img
          :src="require('../assets/støttelogo.png')"
          class="my-3"
          contain
          height="200"
        />
      <div v-if="success == true">
        <h2>Du er en superhelt!</h2>
        <p class="subheading">
          Tak fordi du støtter kampen for minimumsnormeringer i børnehøjde
        </p>
      </div>
      <div v-if="success == false && loaded == true">
        <h2>Ups!</h2>
        <p class="subheading">
          Noget gik galt. Prøv igen om et øjeblik.
        </p>
      </div>
      <div v-if="success == false && loaded == false">
        <h2>Et øjeblik</h2>
        <br/>
        <p class="subheading">
          <v-skeleton-loader
        type="paragraph"
        max-width="400px"
        class="mx-auto"
      ></v-skeleton-loader>
        </p>
      </div>
    </div>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'MedlemResult',

  data: () => ({
    success: false,
    loaded: false
  }),
  methods: {
  },
  async mounted () {
    const queryMedlem = await MedlemsService.activeMedlem(this.$route.query.id)
    console.log(queryMedlem)
    this.success = queryMedlem.data.isActive
    this.loaded = true
  }
}
</script>
